<template>
  <div class="baby_feed_Index">
    <keep-alive :include="includes">
      <router-view></router-view>
    </keep-alive>
  </div>
</template>
<script>
import {mapState} from "vuex";

export default {
  name: "babyFeedingIndex",
  computed: {
    ...mapState({
      includes: (state) => state.includes,
    }),
  },
  data() {
    return {
      info: JSON.parse(localStorage.getItem('userInfo'))
    }
  },
  created() {
    if (this.info?.crm_id) {
      this.getMonthsPeriod()
    }
  },
  methods: {
    // 获取月龄段
    getMonthsPeriod() {
      this.$http.get("/babyWikiRevision/monthsPeriod", {}, res => {
        if (res.code === "200") {
          this.optionList = [];
          for (var i = 0; i < res.data.length; i++) {
            if (res.data[i].id > 0 && res.data[i].id < 7) {
              this.optionList.push(res.data[i]);
            }
          }
          let babyNum = localStorage.getItem('babyNums')
          if (babyNum || babyNum == 0) {
            const babyInfo = JSON.parse(localStorage.getItem('babyInfo'))
            let id = babyInfo && babyInfo.length ? babyInfo.filter(item => item.num == babyNum)[0].tag_id : null
            if (id == 1) {
              id = 2
            } else if (id == 2) {
              id = 1
            }
            const data = this.optionList.filter(item => item.id == id)[0]
            console.log(this.optionList.filter(item => item.id == id), 'babyNumsww')
            if (data) {
              localStorage.setItem("babyFeedYue", JSON.stringify(data))
            } else {
              localStorage.setItem("babyFeedYue", JSON.stringify({}))
            }
          } else {
            const babyInfo = JSON.parse(localStorage.getItem('babyInfo'))
            let id = babyInfo && babyInfo.length ? babyInfo.filter(item => item.birth == this.info.first_baby_birthday)[0]?.tag_id : null
            if (id == 1) {
              id = 2
            } else if (id == 2) {
              id = 1
            }
            const data = this.optionList.filter(item => item.id == id)[0]
            if (data) {
              localStorage.setItem("babyFeedYue", JSON.stringify(data))
            } else {
              localStorage.setItem("babyFeedYue", JSON.stringify({}))
            }

          }
        }
      });
    },
  },
  // watch: {
  //   '$route': {
  //     // handler(newValue) {
  //     //   const babyFeedYue = JSON.parse(localStorage.getItem('babyFeedYue')) || {}
  //     //   console.log(newValue, 'xmhh5_bbsp_allpageview')
  //     //   Exposurer_feeding_Fn.observe('xmhh5_bbsp_allpageview', '.baby_feed_Index', false, {
  //     //     xmhh5_bbsp_pagename: newValue.meta.title,
  //     //     xmhh5_bbsp_monthage: babyFeedYue?.name || "",
  //     //     xmhh5_bbsp_title: newValue.name == 'babyFeedDetails' ? newValue.meta.title : ''
  //     //   })
  //     //   console.log(newValue, 'rrrrrr')
  //     // },
  //     deep: true,
  //     immediate: true
  //   }
  // }
}
</script>
<style lang="less" scoped>
.baby_feed_Index {
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
